import languages, { en as languagesEN, ca as languagesCA } from './languages'

export default {
  preferences: 'Preferencias',
  options: {
    languageConfiguration: 'Configuración de idioma',
    tutorialActivation: 'Reactivación del tutorial de navegación'
  },
  languages
}

export const en = {
  preferences: 'Preferences',
  options: {
    languageConfiguration: 'Language settings',
    tutorialActivation: 'Reactivate navigation tutorial'
  },
  languages: languagesEN
}

export const ca = {
  preferences: 'Preferències',
  options: {
    languageConfiguration: 'Configuració d\'idioma',
    tutorialActivation: 'Reactivació del tutorial de navegació'
  },
  languages: languagesCA
}
